module.exports = __webpack_public_path__ + "static/img/tamarcus-brown-29pFbI_D1Sc-unsplash_thumb.d8e9d84.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/tamarcus-brown-29pFbI_D1Sc-unsplash_thumb.png
// module id = 2hV8
// module chunks = 4